import { ErrorMessage, Icon } from "@justhome/react-ui";
import clsx from "clsx";
import de from "date-fns/locale/de";
import { ComponentProps, FC } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import styles from "./MonthInput.module.css";
import useLocale from "@lib/hooks/useLocale";

registerLocale("de", de);
setDefaultLocale("de");

export interface MonthInputProps
  extends Pick<
    ComponentProps<typeof DatePicker>,
    "onChange" | "onBlur" | "maxDate"
  > {
  value?: Date;
  label?: string;
  errorMessage?: string;
  placeholder?: string;
}

const MonthInput: FC<MonthInputProps> = ({
  label,
  maxDate,
  onChange,
  onBlur,
  value,
  errorMessage,
  placeholder,
}) => {
  const locale = useLocale();
  return (
    <div>
      <label className="text-title-1 flex mb-xs">{label}</label>

      <DatePicker
        locale={locale}
        placeholderText={placeholder}
        onBlur={onBlur}
        wrapperClassName="relative"
        customInput={<input inputMode="none" />}
        className="text-button-1 m:text-body-2 rounded-s border transition-colors ease-out flex items-center text-inherit px-s py-[11px] border-neutral-50 text-neutral-575 hover:border-neutral-100 focus:border-neutral-100 placeholder:text-neutral-150 focus-visible:outline-none w-full"
        calendarClassName={clsx(
          "bg-neutral-0 shadow-3 rounded-m p-s m:p-m border border-neutral-25",
          styles.calendar,
        )}
        popperClassName="z-50 py-2xs"
        monthClassName={() =>
          "text-body-2 inline-block text-center cursor-pointer hover:bg-neutral-25 aria-selected:bg-primary-800 aria-selected:text-neutral-0 rounded-full p-2xs focusable"
        }
        previousYearButtonLabel={
          <Icon type="Left" size="20" className="p-3xs text-primary-800" />
        }
        nextYearButtonLabel={
          <Icon type="Right" size="20" className="p-3xs text-primary-800" />
        }
        showIcon
        icon={
          <Icon
            type="Calendar"
            size="20"
            className="absolute pointer-events-none top-1/2 -translate-y-1/2 right-s text-neutral-150"
          />
        }
        selected={value}
        onChange={onChange}
        dateFormat="MM.yyyy"
        maxDate={maxDate}
        showMonthYearPicker
        showFullMonthYearPicker
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </div>
  );
};

export default MonthInput;
